// extracted by mini-css-extract-plugin
export var faq__heading = "faq-inner-content-module--faq__heading--22Odw";
export var faq__subHeading = "faq-inner-content-module--faq__sub-heading--3QFpP";
export var faq__wrapper = "faq-inner-content-module--faq__wrapper--3BG5i";
export var faq__notFound = "faq-inner-content-module--faq__not-found--Cfp0O";
export var faqModalBackdrop = "faq-inner-content-module--faq-modal-backdrop--2ejia";
export var faqModalWrapper = "faq-inner-content-module--faq-modal-wrapper--2IyxA";
export var content = "faq-inner-content-module--content--1upyH";
export var closeModalWrapper = "faq-inner-content-module--close-modal-wrapper--1sTxD";
export var closeModalButton = "faq-inner-content-module--close-modal-button--14UjE";